import { Grid } from "./models"

export default function getBounds(grid: Grid, margin: number) {
    let isEmpty = true
    let minRow = 0, maxRow = 0, minCol = 0, maxCol = 0
    for (let row in grid) {
        isEmpty = false
        minRow = Math.min(minRow, parseInt(row))
        maxRow = Math.max(maxRow, parseInt(row))
        for (let col in grid[row]) {
            minCol = Math.min(minCol, parseInt(col))
            maxCol = Math.max(maxCol, parseInt(col))
        }
    }
    return { minRow, maxRow, minCol, maxCol, isEmpty }
}